<!-- <div class="kpi-card" [ngClass]="color">
  <div class="card-content">

    <div class="text-section">
      <div class="card-title">
        {{ title }}
      </div>
      <div class="card-value">
        {{ value | number }}
      </div>
    </div>
    <div class="icon-section">
      <mat-icon>{{ icon }}</mat-icon>
    </div>
    <div class="image-section">
  <img *ngIf="image" [src]="image" class="kpi-icon">
</div>

  </div>
</div> -->

<div class="kpi-card" [ngClass]="color" [ngStyle]="{'background': bgColor}">

  <div class="card-content">

    <div class="text-section">
      
      <div class="card-title"
           [ngStyle]="{
             'color': titleColor,
             'font-size': titleSize,
             'font-weight': titleWeight
           }">
        {{ title }}
      </div>

      <div class="card-value"
           [ngStyle]="{
             'color': valueColor,
             'font-size': valueSize
           }">
        {{ value | number }}
      </div>

    </div>
    <div class="icon-section mt-4">
      <img *ngIf="image; else showIcon" [src]="image" class="kpi-icon"  [ngStyle]="{
         'width': imageSize,
         'height': imageSize
       }">

      <ng-template #showIcon>
        <mat-icon *ngIf="icon">{{ icon }}</mat-icon>
      </ng-template>
    </div>

  </div>
</div>
